import Vue from 'vue';
import Vuex from 'vuex';
import * as getters from './getters';
import * as mutations from './mutations';
import * as actions from './actions';

Vue.use(Vuex);

const state = {
    // isAuthenticated:false, //是否认证
    // user:{},
    // loading:false,

    isAuthenticated: !!localStorage.getItem('token'),
    user: JSON.parse(localStorage.getItem('userInfo') || '{}'),
    loading: false

}

export default new Vuex.Store({
    state,
    getters,
    mutations,
    actions
})







// WEBPACK FOOTER //
// ./src/store/index.js